import locales from 'i18n/locales.json';
import { LocalesInfo } from 'i18n/types';
import { FALLBACK_LOCALES } from './constants';

const supportedLocales = new Set(Object.keys(locales as LocalesInfo));
const fallbackLocales = FALLBACK_LOCALES as Record<string, string[]>;

export function detectLocale() {
  const detectedLocale = window.navigator.language;
  const detectedLanguage = detectedLocale.substring(0, 2);

  // Use detected locale if is listed in supported locales
  if (supportedLocales.has(detectedLocale)) return detectedLocale;

  // Otherwise look if there is a fallback for the detected locale
  if (fallbackLocales[detectedLocale])
    return fallbackLocales[detectedLocale][0];

  // If neither work look by language
  if (supportedLocales.has(detectedLanguage)) return detectedLanguage;
  if (fallbackLocales[detectedLanguage])
    return fallbackLocales[detectedLanguage][0];

  // Nothing matches, show English
  return 'en';
}
